import React from 'react'

const InternoRoutes = () => {
  return (
    <div>
      
    </div>
  )
}

export default InternoRoutes
